var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkToDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.0001C12.4183 16.0001 16 12.4184 16 8.00011C16 3.85522 12.8478 0.446566 8.8099 0.0406038V9.68862L10.9257 7.75656C11.2381 7.46993 11.733 7.4848 12.0267 7.78972C12.1695 7.93761 12.2442 8.13085 12.2381 8.334C12.232 8.53754 12.1444 8.72621 11.992 8.86571L8.54743 12.0114C8.408 12.1387 8.224 12.2107 8.02895 12.2145L8.00152 12.216L7.97867 12.2149C7.77638 12.2107 7.59238 12.1387 7.45333 12.0114L4.00876 8.86571C3.856 8.72621 3.76876 8.53754 3.76229 8.334C3.75657 8.13085 3.83124 7.93761 3.9741 7.78972C4.26781 7.4848 4.76229 7.47031 5.07467 7.75656L7.19086 9.68862V0.0405273C3.15258 0.446138 0 3.85496 0 8.00011C0 12.4184 3.58172 16.0001 8 16.0001Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkToDownload);
export default __webpack_public_path__ + "static/media/linkToDownload.e0d091e5.svg";
export { ForwardRef as ReactComponent };